<template>
	<div>
		<navigation msg="加盟商管理/加盟商信息" />
		<router-view></router-view>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import navigation from '@/components/comm/navigation.vue'
	export default{
		data(){
			return {}
		},
		components:{
			navigation
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/alliance/home.vue